import { StateCreator } from 'zustand';

export type RevisionHistoryByIdState = {
    revId: number | undefined;
};

export const initialRevisionHistoryByIdState: RevisionHistoryByIdState = {
    revId: 0
};

export interface RevisionHistoryByIdSlice {
    revisionHistoryById: RevisionHistoryByIdState;
    setRevisionHistoryById: (data: RevisionHistoryByIdState) => void;
}
export const createRevisionHistoryByIdSlice: StateCreator<
    RevisionHistoryByIdSlice,
    [],
    [],
    RevisionHistoryByIdSlice
> = (set) => ({
    revisionHistoryById: { ...initialRevisionHistoryByIdState },
    setRevisionHistoryById: (revisionHistoryByIdData: RevisionHistoryByIdState) =>
        set(() => ({ revisionHistoryById: revisionHistoryByIdData }))
});
